export class SearchPage {
  public page = 1;
  public cursor: string | number | null = null; // カーソルベースページネーション用

  constructor(hash: any = {}) {
    if (Object.keys(hash).length) {
      this.page = hash.page;
      // cursorが明示的にnullまたはundefinedでない場合のみ設定
      if (hash.cursor !== undefined && hash.cursor !== null) {
        this.cursor = hash.cursor;
      }
    }
  }

  // API送信用ハッシュを作成（変数名をスネークケース化）
  getParams() {
    const params: any = {
      page: this.page
    };
    // cursorが存在する場合のみパラメータに含める
    if (this.cursor !== null && this.cursor !== undefined) {
      params.cursor = this.cursor;
    }
    return params;
  }
}
